var _rect, _path, _path2, _path3, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSolidworks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    role: "img",
    "aria-label": "SolidWorks logo",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 12,
    fill: "#fff5f5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 20c5-3 9-4 13-1 3 2 5 1 8-1 5-3 10-2 15 2",
    fill: "none",
    stroke: "#d8252c",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 30c6-4 10-5 14-2 3 2 5 1 8-1 5-3 10-2 16 3",
    fill: "none",
    stroke: "#d8252c",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 41c8-5 13-6 18-2 3 2 5 1 8-1 5-3 10-2 18 3",
    fill: "none",
    stroke: "#d8252c",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 57,
    textAnchor: "middle",
    fontSize: 9,
    fontFamily: "Arial, sans-serif",
    fontWeight: 700,
    fill: "#d8252c"
  }, "SOLIDWORKS")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolidworks);
export default __webpack_public_path__ + "static/media/solidworks.0b6f050af2d953f1847665b94dc2e3fc.svg";
export { ForwardRef as ReactComponent };